<template>
  <header class="header -type-1 js-header bg-light-7" :style="headerStyle">
    <!--data-anim="fade"-->
    <div class="header__container container">
      <div class="row justify-between items-center x-gap-10">
        <div class="col-auto order-1 order-lg-1">
          <div class="header-left">
            <div class="header__logo">
              <router-link to="/">
                <img src="../../assets/images/home/logo.svg" alt="logo" class="logo" />
              </router-link>
            </div>

            <div class="header__explore ml-30 xl:ml-30 xl:d-none">
              <a href="#" class="d-flex items-center" v-click-el-toggle data-el-toggle=".js-explore-toggle">
                {{ $t("menu.discover") }}
              </a>

              <div class="explore-content py-25 rounded-8 bg-white toggle-element js-click-dropdown js-explore-toggle">
                <div class="explore__item" v-for="(category, i) in categories" :key="i">
                  <a href="/courses" class="d-flex items-center justify-between explore-link">
                    {{ category.label }}
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <button @click="goToFilteredCoureses(child.value)" v-for="(child, x) in category?.children"
                      :key="x">
                      {{ child.label }}
                    </button>

                    <!----<a href="courses-single-2.html">Planning Scheduling and Reporting using Primavera and
                      Excel (PSR)</a>
                    <a href="courses-single-3.html">Delay Analysis & EOT Claims</a>
                    <a href="courses-single-4.html">Interactive Dashboards Using Power BI</a>
                    <a href="courses-single-5.html">Cost Estimation and Cost Control (CEC)</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Risk Management Using Primavera Risk Analysis</a>-->

                    <div class="explore__item align-self-end mt-auto">
                      <router-link to="/courses" class="main-button">
                        <span> Browse </span>
                        <span class="rotate-svg">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
                              fill="white" />
                          </svg>
                        </span>
                      </router-link>
                    </div>
                  </div>
                </div>

                <!----<div class="explore__item">
                  <a href="#" class="d-flex items-center justify-between explore-link">
                    Development
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <a href="courses-single-1.html">Popular Courses</a>
                    <a href="courses-single-2.html">Planning Scheduling and Reporting using Primavera and
                      Excel (PSR)</a>
                    <a href="courses-single-3.html">Delay Analysis & EOT Claims</a>
                    <a href="courses-single-4.html">Interactive Dashboards Using Power BI</a>
                    <a href="courses-single-5.html">Cost Estimation and Cost Control (CEC)</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Risk Management Using Primavera Risk Analysis</a>
                  </div>
                </div>

                <div class="explore__item">
                  <a href="#">Business</a>
                </div>

                <div class="explore__item">
                  <a href="#">Design</a>
                </div>

                <div class="explore__item">
                  <a href="#" class="d-flex items-center justify-between explore-link">
                    Finance & Accounting
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <a href="courses-single-1.html">Popular Courses</a>
                    <a href="courses-single-2.html">Planning Scheduling and Reporting using Primavera and
                      Excel (PSR)</a>
                    <a href="courses-single-3.html">Delay Analysis & EOT Claims</a>
                    <a href="courses-single-4.html">Interactive Dashboards Using Power BI</a>
                    <a href="courses-single-5.html">Cost Estimation and Cost Control (CEC)</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Risk Management Using Primavera Risk Analysis</a>
                  </div>
                </div>

                <div class="explore__item">
                  <a href="courses-single-6.html">It & Software</a>
                </div>

                <div class="explore__item">
                  <a href="#" class="d-flex items-center justify-between explore-link">
                    Office Productivity
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <a href="courses-single-1.html">Web Design</a>
                    <a href="courses-single-2.html">Graphic Design</a>
                    <a href="courses-single-3.html">Design Tools</a>
                    <a href="courses-single-4.html">User Experience Design</a>
                    <a href="courses-single-5.html">Game Design</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Fashion Design</a>
                    <a href="courses-single-2.html">Interior Design</a>
                  </div>
                </div>

                <div class="explore__item">
                  <a href="#" class="d-flex items-center justify-between explore-link">
                    Personal Development
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <a href="courses-single-1.html">Web Design</a>
                    <a href="courses-single-2.html">Graphic Design</a>
                    <a href="courses-single-3.html">Design Tools</a>
                    <a href="courses-single-4.html">User Experience Design</a>
                    <a href="courses-single-5.html">Game Design</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Fashion Design</a>
                    <a href="courses-single-2.html">Interior Design</a>
                  </div>
                </div>

                <div class="explore__item">
                  <a href="#" class="d-flex items-center justify-between explore-link">
                    Marketing
                    <div class="icon-chevron-right text-11"></div>
                  </a>
                  <div class="explore__subnav rounded-8">
                    <a href="courses-single-1.html">Web Design</a>
                    <a href="courses-single-2.html">Graphic Design</a>
                    <a href="courses-single-3.html">Design Tools</a>
                    <a href="courses-single-4.html">User Experience Design</a>
                    <a href="courses-single-5.html">Game Design</a>
                    <a href="courses-single-6.html">3D & Animation</a>
                    <a href="courses-single-1.html">Fashion Design</a>
                    <a href="courses-single-2.html">Interior Design</a>
                  </div>
                </div>
               
                <div class="explore__item">
                  <a href="#">Health & Fitness</a>
                </div>

                <div class="explore__item">
                  <a href="courses-single-1.html">IT & Software</a>
                </div> ---------------------->
              </div>
              <!-----End Of Discover menu----------------->
            </div>
          </div>
        </div>

        <!-----Search Button for large screen------------>
        <div class="col-lg-3 nav-search lg:d-none xl-d-block order-lg-2 d-flex justify-between align-items-center">
          <div class="input-group">
            <input type="text" class="form-control" :placeholder="$t('search')" aria-label="Search"
              aria-describedby="basic-addon1" v-model.trim="searchTerm" @change="searchData" />
            <span class="input-group-text rotate-90" id="basic-addon1">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                  d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
              </svg>
            </span>
          </div>
        </div>
        <!---------------------------------->
        <div class="header-menu js-mobile-menu-toggle" ref="js-mobile-menu-toggle">
          <div class="header-menu__content">
            <div class="mobile-bg js-mobile-bg"></div>

            <!---Auth Buttons For small Screens------>
            <div class="d-none xl:d-flex items-center px-20 py-20 border-bottom-light" v-if="!isAuthenticated">
              <router-link to="/login" class="text-dark-1">{{
                $t("login")
              }}</router-link>
              <router-link to="/signup" class="text-dark-1 ml-30">
                {{ $t("signup") }}</router-link>
            </div>
            <div class="d-flex pb-12 px-20 pt-4" v-else>
              <div class="user-img-1 d-flex align-items-center justify-content-center bg-light-3 rounded-full-1 p-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                    stroke="#062B3B" stroke-width="1.5" stroke-linejoin="round" />
                  <path
                    d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                    stroke="#062B3B" stroke-width="1.5" />
                </svg>
                <!--<img src="" width="" height="" alt="user-image" class="img-fluid">-->
              </div>
              <div class="d-flex flex-column y-gap-5 user-name ml-10">
                <p>{{ userData?.name }}</p>
                <span v-if="userData?.email">{{ userData?.email }}</span>
              </div>
            </div>
            <!---Menu For small screen ------------>
            <MenuComponent :learningLink="userData?.my_learning_link"/>

            <div class="mobile-footer px-20 py-20 border-top-light js-mobile-footer">
              <div class="mobile-footer__number">
                <div class="text-17 fw-500 text-dark-1">Call us</div>
                <div class="text-17 fw-500 text-purple-1">+201 027 857 863</div>
              </div>

              <div class="lh-2 mt-10">
                <div>Cairo - Egypt<br /></div>
                <div>info@planning-force.com</div>
              </div>

              <div class="mobile-socials mt-10">
                <a href="https://www.facebook.com/Ali.Katary.15" target="_blank"
                  class="d-flex items-center justify-center rounded-full size-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none">
                    <path
                      d="M8.55078 25.2904C8.55174 29.3261 9.99211 33.2291 12.613 36.298C15.2339 39.3668 18.8634 41.4002 22.8493 42.0327V30.1882H18.5497V25.2904H22.8544V21.562C22.7593 20.6893 22.8576 19.8065 23.1422 18.9761C23.4268 18.1457 23.8907 17.3882 24.501 16.7573C25.1114 16.1264 25.8531 15.6376 26.6737 15.3257C27.4942 15.0138 28.3733 14.8864 29.2486 14.9525C30.5197 14.9728 31.7907 15.0864 33.0448 15.2914V19.4588H30.9027C30.5386 19.4111 30.1684 19.4459 29.8196 19.5605C29.4707 19.6751 29.1521 19.8666 28.8872 20.1209C28.6224 20.3752 28.418 20.6858 28.2893 21.0296C28.1606 21.3735 28.1108 21.742 28.1436 22.1077V25.2904H32.8397L32.089 30.1899H28.1436V42.0327C31.3427 41.5271 34.3298 40.1155 36.7515 37.9649C39.1731 35.8144 40.9278 33.0149 41.8079 29.8981C42.6879 26.7812 42.6564 23.4774 41.7171 20.3779C40.7778 17.2784 38.97 14.5129 36.5078 12.4089C34.0456 10.3049 31.032 8.95053 27.8239 8.50606C24.6159 8.06159 21.3476 8.54568 18.4061 9.901C15.4646 11.2563 12.9731 13.4261 11.2264 16.1535C9.47983 18.8809 8.5513 22.0517 8.55078 25.2904Z"
                      fill="white" />
                  </svg>
                </a>

                <!-- <a href="#" class="d-flex items-center justify-center rounded-full size-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                    <path
                      d="M43.0949 15.2938C42.166 16.6776 40.9907 17.9098 39.6258 18.8956C39.6448 19.1799 39.6448 19.4832 39.6448 19.7865C39.6448 28.9806 32.6497 39.5774 19.8729 39.5774C15.9488 39.5774 12.2902 38.421 9.2002 36.4495C9.74994 36.5064 10.2997 36.5443 10.8684 36.5443C14.129 36.5443 17.1241 35.4259 19.4937 33.5681C18.0442 33.5381 16.6402 33.0562 15.4779 32.1895C14.3156 31.3229 13.4529 30.1148 13.0105 28.7341C13.4276 28.81 13.8636 28.8668 14.3185 28.8668C14.9441 28.8668 15.5697 28.772 16.1384 28.6204C14.5661 28.2976 13.1532 27.4426 12.138 26.1994C11.1227 24.9562 10.5672 23.401 10.5651 21.7959V21.7201C11.5129 22.232 12.5745 22.5542 13.7119 22.5921C12.7599 21.9535 11.9799 21.0902 11.441 20.0784C10.9021 19.0667 10.6207 17.9377 10.622 16.7914C10.622 15.5213 10.9632 14.327 11.5698 13.3033C15.001 17.5117 20.1193 20.2794 25.9011 20.5638C25.7874 20.0519 25.7116 19.5211 25.7116 18.9714C25.7166 17.1295 26.4518 15.3648 27.7559 14.0642C29.0601 12.7636 30.8268 12.0332 32.6687 12.0332C34.6781 12.0332 36.479 12.8673 37.7491 14.2322C39.3225 13.9099 40.8201 13.3412 42.166 12.545C41.6353 14.1564 40.5358 15.5213 39.0951 16.3743C40.4762 16.2233 41.8256 15.8588 43.0949 15.2938Z"
                      fill="white" />
                  </svg>
                </a> -->

                <!-- <a href="#" class="d-flex items-center justify-center rounded-full size-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                    <path
                      d="M42.8295 18.4271C42.8105 17.0016 42.5437 15.5902 42.0409 14.2561C41.6049 13.1309 40.9389 12.1089 40.0856 11.2556C39.2323 10.4023 38.2103 9.73631 37.085 9.3003C35.7681 8.80595 34.3769 8.53865 32.9705 8.50977C31.1598 8.42884 30.5858 8.40625 25.9894 8.40625C21.3931 8.40625 20.804 8.40625 19.0065 8.50977C17.6007 8.53886 16.2102 8.80616 14.8938 9.3003C13.7684 9.73601 12.7463 10.4018 11.8929 11.2552C11.0395 12.1086 10.3737 13.1307 9.93799 14.2561C9.44265 15.5721 9.17593 16.963 9.14935 18.3688C9.06841 20.1813 9.04395 20.7554 9.04395 25.3517C9.04395 29.9481 9.04395 30.5353 9.14935 32.3347C9.17758 33.7426 9.44297 35.1317 9.93799 36.4511C10.3744 37.5762 11.0408 38.5979 11.8944 39.4509C12.7481 40.3039 13.7703 40.9695 14.8957 41.4051C16.2084 41.9193 17.5993 42.2057 19.0083 42.252C20.8209 42.333 21.395 42.3574 25.9913 42.3574C30.5877 42.3574 31.1768 42.3574 32.9743 42.252C34.3806 42.2244 35.7719 41.9577 37.0888 41.4634C38.2138 41.0269 39.2355 40.3608 40.0887 39.5075C40.942 38.6542 41.6081 37.6325 42.0446 36.5076C42.5397 35.19 42.805 33.801 42.8333 32.3912C42.9142 30.5805 42.9387 30.0064 42.9387 25.4082C42.9349 20.8119 42.9349 20.2284 42.8295 18.4271ZM25.9781 34.0438C21.171 34.0438 17.2767 30.1495 17.2767 25.3423C17.2767 20.5352 21.171 16.6409 25.9781 16.6409C28.2859 16.6409 30.4991 17.5576 32.131 19.1895C33.7628 20.8213 34.6796 23.0346 34.6796 25.3423C34.6796 27.6501 33.7628 29.8633 32.131 31.4952C30.4991 33.127 28.2859 34.0438 25.9781 34.0438ZM35.0259 18.3481C34.7594 18.3483 34.4954 18.296 34.2491 18.1941C34.0028 18.0922 33.7791 17.9428 33.5906 17.7543C33.4022 17.5659 33.2527 17.3421 33.1508 17.0958C33.0489 16.8495 32.9966 16.5856 32.9969 16.319C32.9969 16.0527 33.0493 15.789 33.1513 15.5429C33.2532 15.2969 33.4026 15.0733 33.5909 14.885C33.7792 14.6966 34.0028 14.5473 34.2488 14.4453C34.4949 14.3434 34.7586 14.291 35.025 14.291C35.2913 14.291 35.555 14.3434 35.8011 14.4453C36.0471 14.5473 36.2707 14.6966 36.459 14.885C36.6473 15.0733 36.7967 15.2969 36.8987 15.5429C37.0006 15.789 37.053 16.0527 37.053 16.319C37.053 17.4408 36.1458 18.3481 35.0259 18.3481Z"
                      fill="white" />
                    <path
                      d="M25.9775 30.994C29.0991 30.994 31.6297 28.4634 31.6297 25.3417C31.6297 22.2201 29.0991 19.6895 25.9775 19.6895C22.8558 19.6895 20.3252 22.2201 20.3252 25.3417C20.3252 28.4634 22.8558 30.994 25.9775 30.994Z"
                      fill="white" />
                  </svg>
                </a> -->

                <a href="https://www.linkedin.com/company/planning-force/?viewAsMember=true" target="_blank"
                  class="d-flex items-center justify-center rounded-full size-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none">
                    <path
                      d="M24.0909 0.710938H2.4293C1.39339 0.710938 0.552734 1.53183 0.552734 2.54267V24.2978C0.552734 25.31 1.39339 26.132 2.4293 26.132H24.0909C25.1275 26.132 25.9738 25.31 25.9738 24.2978V2.54267C25.9738 1.53183 25.1275 0.710938 24.0909 0.710938ZM8.0922 22.3732H4.31999V10.2421H8.0922V22.3732ZM6.20609 8.58334C5.91897 8.58334 5.63466 8.52677 5.36941 8.41685C5.10416 8.30693 4.86317 8.14582 4.66021 7.94273C4.45725 7.73963 4.29629 7.49854 4.18655 7.23322C4.0768 6.9679 4.0204 6.68355 4.02059 6.39643C4.02059 5.81684 4.25083 5.26099 4.66066 4.85117C5.07049 4.44134 5.62633 4.2111 6.20592 4.2111C6.7855 4.2111 7.34135 4.44134 7.75118 4.85117C8.16101 5.26099 8.39125 5.81684 8.39125 6.39643C8.39125 6.97613 8.16108 7.53211 7.75134 7.94219C7.34159 8.35226 6.78579 8.58288 6.20609 8.58334ZM22.2136 22.3732H18.4474V16.4741C18.4474 15.0668 18.4199 13.2573 16.4875 13.2573C14.5251 13.2573 14.2261 14.79 14.2261 16.3721V22.3736H10.4571V10.2421H14.0743V11.8987H14.1258C14.6293 10.9454 15.8594 9.93949 17.6939 9.93949C21.5092 9.93949 22.2139 12.4512 22.2139 15.7189L22.2136 22.3732Z"
                      fill="white" />
                  </svg>
                </a>

                <a href="https://www.youtube.com/@alikatary" target="_blank"
                  class="d-flex items-center justify-center rounded-full size-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="51" viewBox="0 0 52 51" fill="none">
                    <path
                      d="M42.2062 17.2875C42.0133 16.5718 41.6363 15.9191 41.1128 15.3944C40.5893 14.8697 39.9374 14.4913 39.2222 14.2967C36.5701 13.5685 25.9601 13.5567 25.9601 13.5567C25.9601 13.5567 15.3517 13.5448 12.698 14.2408C11.9832 14.4443 11.3327 14.8281 10.8089 15.3554C10.2852 15.8827 9.90581 16.5358 9.70719 17.252C9.00775 19.904 9.00098 25.4047 9.00098 25.4047C9.00098 25.4047 8.9942 30.9324 9.68856 33.5573C10.0781 35.0087 11.2212 36.1552 12.6743 36.5464C15.3534 37.2747 25.9347 37.2865 25.9347 37.2865C25.9347 37.2865 36.5447 37.2984 39.1968 36.604C39.9123 36.4098 40.5647 36.0323 41.0896 35.5086C41.6144 34.985 41.9935 34.3334 42.1893 33.6183C42.8904 30.9679 42.8955 25.469 42.8955 25.469C42.8955 25.469 42.9293 19.9396 42.2062 17.2875ZM22.5662 30.5005L22.5747 20.3393L31.393 25.4284L22.5662 30.5005Z"
                      fill="white" />
                  </svg>
                </a>

              </div>
            </div>
          </div>
          <!----Menu close Button--------->
          <div class="header-menu-close" @click="hideSidebar">
            <div class="size-40 d-flex items-center justify-center rounded-full bg-white">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M6 18 17.94 6M18 18 6.06 6" />
              </svg>
            </div>
          </div>

          <div class="header-menu-bg"></div>
        </div>

        <div class="col-auto order-2 order-lg-2 d-flex">
          <!----- user icons for small screens ------------>
          <div class="nav-search d-flex justify-between align-items-center">
            <!----Search button for small screens------------->
            <button aria-label="search"
              class="d-flex items-center lg:d-inline-block mt-5 xl:d-none xxl:d-none rotate-90"
              @click="toggleSearchMenu">
              <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                  d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
              </svg>
            </button>

            <!-- Search Menu -->
            <div v-show="isSearchMenuVisible">
              <div class="header-search pt-90 shadow-4" @click.stop>
                <div class="container">
                  <div class="header-search__field">
                    <div>
                      <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                          d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z" />
                      </svg>
                    </div>
                    <input type="text" class="col-12 text-18 lh-12 text-dark-1 fw-500"
                      placeholder="What do you want to learn?" v-model.trim="searchTerm" @change="searchData"
                      @blur="hideSearchMenu" />

                    <!-- Close Button -->
                    <button aria-label="close" class="d-flex items-center justify-center size-40 rounded-full"
                      @click="hideSearchMenu">
                      <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M6 18 17.94 6M18 18 6.06 6" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="header-search__bg" @click="hideSearchMenu"></div>
            </div>
            <!---end of search for small screens----------->
          </div>
          <div class="header-right d-flex items-center">
            <div class="header-right__icons d-flex items-center">
              <div class="d-flex align-items-center x-gap-15 lg:d-none xxl:d-flex">
                <div class="header-right__buttons d-flex items-center">
                  <router-link to="/join-us" v-if="isAuthenticated" class="teach fw-600" style="text-transform: capitalize">
                    {{ $t("menu.teach_with_us") }} 
                  </router-link>
                </div>
                
                <div class="header-right__buttons d-flex items-center learning" v-if="isAuthenticated">
                  <a  :href="userData?.my_learning_link"
                    class="teach fw-600 exact" style="text-transform: capitalize">{{
                      $t("my_learning") }}</a>
                </div>
              </div>

              <!------user and notification buttons for small screens -------------->
              <div class="header-right__buttons items-center x-gap-20 ml-15 d-flex xxl:d-none" v-if="isAuthenticated">
                <button aria-label="user" class="button notification" v-click-el-toggle
                  data-el-toggle=".js-toggle-notification">
                  <span class="d-block notification-icon" v-if="notifications?.length !== 0"></span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <path
                      d="M21.5303 16.4697L19.5 14.4395V11.75C19.4977 9.89138 18.8063 8.09964 17.5595 6.72124C16.3127 5.34284 14.5991 4.4757 12.75 4.2875V2.75H11.25V4.2875C9.40093 4.4757 7.68732 5.34284 6.44053 6.72124C5.19373 8.09964 4.50233 9.89138 4.5 11.75V14.4395L2.46975 16.4697C2.32909 16.6104 2.25004 16.8011 2.25 17V19.25C2.25 19.4489 2.32902 19.6397 2.46967 19.7803C2.61032 19.921 2.80109 20 3 20H8.25V20.5828C8.23335 21.5343 8.5686 22.4585 9.19145 23.1781C9.81429 23.8977 10.6809 24.362 11.625 24.482C12.1464 24.5337 12.6728 24.4757 13.1704 24.3117C13.6681 24.1478 14.1259 23.8815 14.5144 23.53C14.9029 23.1785 15.2136 22.7495 15.4264 22.2707C15.6392 21.792 15.7494 21.2739 15.75 20.75V20H21C21.1989 20 21.3897 19.921 21.5303 19.7803C21.671 19.6397 21.75 19.4489 21.75 19.25V17C21.75 16.8011 21.6709 16.6104 21.5303 16.4697ZM14.25 20.75C14.25 21.3467 14.0129 21.919 13.591 22.341C13.169 22.7629 12.5967 23 12 23C11.4033 23 10.831 22.7629 10.409 22.341C9.98705 21.919 9.75 21.3467 9.75 20.75V20H14.25V20.75ZM20.25 18.5H3.75V17.3105L5.78025 15.2803C5.92091 15.1396 5.99996 14.9489 6 14.75V11.75C6 10.1587 6.63214 8.63258 7.75736 7.50736C8.88258 6.38214 10.4087 5.75 12 5.75C13.5913 5.75 15.1174 6.38214 16.2426 7.50736C17.3679 8.63258 18 10.1587 18 11.75V14.75C18 14.9489 18.0791 15.1396 18.2197 15.2803L20.25 17.3105V18.5Z"
                      fill="#062B3B" />
                  </svg>
                </button>
                <button aria-label="user" class="button" id="user" v-click-el-toggle data-el-toggle=".js-toggle-user">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                      d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                      stroke="#062B3B" stroke-width="1.5" stroke-linejoin="round" />
                    <path
                      d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                      stroke="#062B3B" stroke-width="1.5" />
                  </svg>
                </button>
              </div>
              <!------End of user and notification buttons for small screens -------------->
              <!----
              <div class="relative cart">
                <router-link to="/cart">
                  <img src="../../assets/images/home/Group.svg" alt="cart" width="" height="" />
                </router-link>
              </div>-->
              <div class="relative d-lg-none mx-2">
                <a :href="userData?.my_learning_link"
                  v-if="isAuthenticated">
                  <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 6.03v13m0-13c-2.819-.831-4.715-1.076-8.029-1.023A.99.99 0 0 0 3 6v11c0 .563.466 1.014 1.03 1.007 3.122-.043 5.018.212 7.97 1.023m0-13c2.819-.831 4.715-1.076 8.029-1.023A.99.99 0 0 1 21 6v11c0 .563-.466 1.014-1.03 1.007-3.122-.043-5.018.212-7.97 1.023" />
                  </svg>
                </a>
              </div>
              <!---------Language DropDown small screens--------->
              <div class="language-dropdown ml-8 d-block xxl:d-none">
                <div class="dropdown-btn" v-click-el-toggle data-el-toggle=".js-toggle-small-laguage">
                  <img v-if="$i18n.locale === 'en'" src="https://flagcdn.com/w320/us.png" alt="US Flag" />
                  <img v-else-if="$i18n.locale === 'ar'" src="https://flagcdn.com/w320/eg.png" alt="eg Flag" />
                </div>

                <div class="dropdown-menu js-click-dropdown js-toggle-small-laguage" id="dropdown-menu">
                  <div v-for="language in languages" :key="language.code"
                    @click="changeLanguage(language.code, language.direction)" class="dropdown-item">
                    <img :src="`${language.flag}`" alt="US Flag" />
                    <span>{{ language.label }}</span>
                  </div>
                </div>
              </div>
              <!----Menu toggle button------------------>
              <div class="show-bars ml-20">
                <button aria-label="bars" class="items-center bars-button" v-click-el-toggle
                  data-el-toggle=".js-mobile-menu-toggle">
                  <svg class="text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                    width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h10" />
                  </svg>
                </button>
              </div>
            </div>

            <!-------User Profile and notification buttons For Large Screen----------------->
            <div class="header-right__buttons items-center x-gap-20 ml-5 mr-10 d-none xxl:d-flex"
              v-if="isAuthenticated">
              <button aria-label="notification" class="button notification" v-click-el-toggle
                data-el-toggle=".js-toggle-notification" style="margin-left: -3px">
                <span class="d-block notification-icon" v-if="notifications?.length !== 0"></span>
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                  <path
                    d="M21.5303 16.4697L19.5 14.4395V11.75C19.4977 9.89138 18.8063 8.09964 17.5595 6.72124C16.3127 5.34284 14.5991 4.4757 12.75 4.2875V2.75H11.25V4.2875C9.40093 4.4757 7.68732 5.34284 6.44053 6.72124C5.19373 8.09964 4.50233 9.89138 4.5 11.75V14.4395L2.46975 16.4697C2.32909 16.6104 2.25004 16.8011 2.25 17V19.25C2.25 19.4489 2.32902 19.6397 2.46967 19.7803C2.61032 19.921 2.80109 20 3 20H8.25V20.5828C8.23335 21.5343 8.5686 22.4585 9.19145 23.1781C9.81429 23.8977 10.6809 24.362 11.625 24.482C12.1464 24.5337 12.6728 24.4757 13.1704 24.3117C13.6681 24.1478 14.1259 23.8815 14.5144 23.53C14.9029 23.1785 15.2136 22.7495 15.4264 22.2707C15.6392 21.792 15.7494 21.2739 15.75 20.75V20H21C21.1989 20 21.3897 19.921 21.5303 19.7803C21.671 19.6397 21.75 19.4489 21.75 19.25V17C21.75 16.8011 21.6709 16.6104 21.5303 16.4697ZM14.25 20.75C14.25 21.3467 14.0129 21.919 13.591 22.341C13.169 22.7629 12.5967 23 12 23C11.4033 23 10.831 22.7629 10.409 22.341C9.98705 21.919 9.75 21.3467 9.75 20.75V20H14.25V20.75ZM20.25 18.5H3.75V17.3105L5.78025 15.2803C5.92091 15.1396 5.99996 14.9489 6 14.75V11.75C6 10.1587 6.63214 8.63258 7.75736 7.50736C8.88258 6.38214 10.4087 5.75 12 5.75C13.5913 5.75 15.1174 6.38214 16.2426 7.50736C17.3679 8.63258 18 10.1587 18 11.75V14.75C18 14.9489 18.0791 15.1396 18.2197 15.2803L20.25 17.3105V18.5Z"
                    fill="#062B3B" />
                </svg>
              </button>

              <button aria-label="user" class="button" id="user-1" v-click-el-toggle data-el-toggle=".js-toggle-user">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                    stroke="#062B3B" stroke-width="1.5" stroke-linejoin="round" />
                  <path
                    d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                    stroke="#062B3B" stroke-width="1.5" />
                </svg>
              </button>
            </div>
            <!---------Auth buttons For Large Screen--------->
            <div class="header-right__buttons d-none items-center ml-15" :class="{ 'xxl:d-flex ': !isAuthenticated }">
              <!-- xxl:d-flex -->
              <router-link to="/login" class="button -underline fw-600 login">{{
                $t("login")
              }}</router-link>
              <router-link to="/signup" class="button -sm fw-600 sign-up ml-10">{{ $t("signup") }}</router-link>
            </div>

            <!---------Language DropDown for large screens--------->
            <div class="language-dropdown ml-8 xxl:d-block d-none">
              <div class="dropdown-btn shrink-0" v-click-el-toggle data-el-toggle=".js-toggle-large-laguage">
                <img v-if="$i18n.locale === 'en'" src="https://flagcdn.com/w320/us.png" alt="US Flag" />
                <img v-else-if="$i18n.locale === 'ar'" src="https://flagcdn.com/w320/eg.png" alt="eg Flag" />
              </div>
              <div class="dropdown-menu js-click-dropdown js-toggle-large-laguage">
                <div v-for="language in languages" :key="language.code"
                  @click="changeLanguage(language.code, language.direction)" class="dropdown-item">
                  <img :src="`${language.flag}`" alt="US Flag" />
                  <span>{{ language.label }}</span>
                </div>
              </div>
              <!----<div class="dropdown-menu js-click-dropdown js-toggle-large-laguage">
                <div @click="switchLanguage('en')">
                  <img src="https://flagcdn.com/w320/us.png" alt="US Flag">
                  <span>English</span>
                </div>
                <div @click="switchLanguage('ar-ae')">
                  <img src="https://flagcdn.com/w320/eg.png" alt="UAE Flag">
                  <span>العربية (EG)</span>
                </div>
              </div>-->
            </div>
            <!-------------------------->
            <!----------User data DropDown------------->
            <div id="user-dropdown" class="js-click-dropdown js-toggle-user">
              <div>
                <!------user profile-------->
                <div class="d-flex pb-12">
                  <div class="user-img d-flex align-items-center justify-content-center x-gap-5">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path
                        d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                        stroke="#062B3B" stroke-width="1.5" stroke-linejoin="round" />
                      <path
                        d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                        stroke="#062B3B" stroke-width="1.5" />
                    </svg>
                    <!--<img src="" width="" height="" alt="user-image" class="img-fluid">-->
                  </div>
                  <div class="d-flex flex-column y-gap-5 user-name ml-10">
                    <p>{{ userData?.name }}</p>
                    <span v-if="userData?.email">{{ userData?.email }}</span>
                  </div>
                </div>
                <!--user navigation--->
                <ul class="px-30 pt-20 pb-30 border-top-light user-Dashboard d-flex flex-column">
                  <li>
                    <a :href="userData ? userData['access_link'] : '/'">
                      <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M16.0987 11.2501H12.8695C12.4414 11.2496 12.0307 11.419 11.7273 11.7209C11.4239 12.0229 11.2527 12.4329 11.2512 12.8609V16.0901C11.2509 16.3027 11.2926 16.5132 11.3739 16.7097C11.4552 16.9061 11.5743 17.0846 11.7247 17.2349C11.875 17.3852 12.0535 17.5044 12.2499 17.5857C12.4464 17.6669 12.6569 17.7086 12.8695 17.7084H16.0987C16.5266 17.7067 16.9363 17.5353 17.2381 17.232C17.5399 16.9286 17.7091 16.518 17.7087 16.0901V12.8609C17.7089 12.6494 17.6674 12.44 17.5866 12.2445C17.5057 12.0491 17.3871 11.8715 17.2376 11.722C17.088 11.5724 16.9105 11.4539 16.715 11.373C16.5196 11.2922 16.3102 11.2507 16.0987 11.2509M7.13116 11.2501H3.90199C3.47415 11.2525 3.06466 11.4242 2.76299 11.7276C2.46132 12.0309 2.29199 12.4414 2.29199 12.8692V16.0984C2.29177 16.3099 2.33327 16.5194 2.4141 16.7148C2.49493 16.9102 2.61352 17.0878 2.76306 17.2373C2.91261 17.3869 3.09018 17.5055 3.28561 17.5863C3.48105 17.6671 3.6905 17.7086 3.90199 17.7084H7.13116C7.55906 17.7089 7.96969 17.5396 8.27304 17.2379C8.57639 16.9361 8.74773 16.5263 8.74949 16.0984V12.8692C8.74971 12.6567 8.708 12.4461 8.62675 12.2497C8.5455 12.0532 8.4263 11.8747 8.27598 11.7244C8.12566 11.5741 7.94717 11.4549 7.75073 11.3737C7.55428 11.2924 7.34374 11.2507 7.13116 11.2509M7.13116 2.29175H3.90199C3.6905 2.29153 3.48105 2.33302 3.28561 2.41386C3.09018 2.49469 2.91261 2.61327 2.76306 2.76282C2.61352 2.91236 2.49493 3.08994 2.4141 3.28537C2.33327 3.4808 2.29177 3.69026 2.29199 3.90175V7.13092C2.29155 7.55882 2.46076 7.96944 2.76256 8.2728C3.06435 8.57615 3.47409 8.74748 3.90199 8.74925H7.13116C7.34374 8.74947 7.55428 8.70776 7.75073 8.62651C7.94717 8.54526 8.12566 8.42606 8.27598 8.27574C8.4263 8.12542 8.5455 7.94693 8.62675 7.75048C8.708 7.55404 8.74971 7.3435 8.74949 7.13092V3.90175C8.74773 3.47385 8.57639 3.0641 8.27304 2.76231C7.96969 2.46052 7.55906 2.2913 7.13116 2.29175ZM16.0987 2.29175H12.8695C12.4416 2.2913 12.031 2.46052 11.7276 2.76231C11.4243 3.0641 11.2529 3.47385 11.2512 3.90175V7.13092C11.2514 7.56006 11.422 7.97156 11.7254 8.27501C12.0289 8.57845 12.4404 8.74903 12.8695 8.74925H16.0987C16.5266 8.74748 16.9363 8.57615 17.2381 8.2728C17.5399 7.96944 17.7091 7.55882 17.7087 7.13092V3.90175C17.7089 3.69026 17.6674 3.4808 17.5866 3.28537C17.5057 3.08994 17.3871 2.91236 17.2376 2.76282C17.088 2.61327 16.9105 2.49469 16.715 2.41386C16.5196 2.33302 16.3102 2.29153 16.0987 2.29175Z"
                            stroke="#062B3B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>
                      <span> {{ $t("dashboard") }} </span>
                    </a>
                  </li>

                  <li>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M10.0003 3.96581L9.55033 4.48581C9.60863 4.55839 9.67853 4.61613 9.75585 4.65557C9.83316 4.695 9.91631 4.71533 10.0003 4.71533C10.0843 4.71533 10.1675 4.695 10.2448 4.65557C10.3221 4.61613 10.392 4.55839 10.4503 4.48581L10.0003 3.96581ZM7.85533 16.7878C6.59199 15.5928 5.21116 14.4258 4.11533 12.9458C3.04199 11.4938 2.29199 9.80081 2.29199 7.60281H1.04199C1.04199 10.2688 1.96699 12.3028 3.18116 13.9418C4.37283 15.5518 5.89283 16.8418 7.08116 17.9658L7.85533 16.7878ZM2.29199 7.60281C2.29199 5.45281 3.30449 3.64881 4.68699 2.88981C6.03033 2.15281 7.83533 2.34781 9.55033 4.48581L10.4503 3.44681C8.41699 0.909806 6.05366 0.490806 4.16699 1.52581C2.32199 2.53881 1.04199 4.89081 1.04199 7.60281H2.29199ZM7.08116 17.9658C7.50866 18.3698 7.96699 18.7998 8.43116 19.1258C8.89533 19.4518 9.42533 19.7158 10.0003 19.7158V18.2158C9.74199 18.2158 9.43866 18.0958 9.06199 17.8308C8.68449 17.5668 8.29366 17.2028 7.85533 16.7878L7.08116 17.9658ZM12.9195 17.9658C14.1078 16.8408 15.6278 15.5528 16.8195 13.9418C18.0337 12.3018 18.9587 10.2688 18.9587 7.60281H17.7087C17.7087 9.80081 16.9587 11.4938 15.8853 12.9458C14.7895 14.4258 13.4087 15.5928 12.1453 16.7878L12.9195 17.9658ZM18.9587 7.60281C18.9587 4.89081 17.6795 2.53881 15.8337 1.52581C13.947 0.490806 11.5853 0.909806 9.55033 3.44581L10.4503 4.48581C12.1653 2.34881 13.9703 2.15281 15.3137 2.88981C16.6962 3.64881 17.7087 5.45181 17.7087 7.60281H18.9587ZM12.1453 16.7878C11.707 17.2028 11.3162 17.5668 10.9387 17.8308C10.5612 18.0948 10.2587 18.2158 10.0003 18.2158V19.7158C10.5753 19.7158 11.1053 19.4508 11.5695 19.1258C12.0345 18.7998 12.492 18.3698 12.9195 17.9658L12.1453 16.7878Z"
                          fill="#062B3B" />
                      </svg>
                    </span>
                    <router-link to="/wishlist">
                      {{ $t("wishlist") }}
                    </router-link>
                  </li>

                  <li>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M3.34917 6.80908H16.6513C17.042 6.80908 17.4168 6.96429 17.6932 7.24059C17.9696 7.51688 18.1249 7.89163 18.125 8.28242V16.1932C18.1248 16.5842 17.9694 16.959 17.693 17.2354C17.4166 17.5118 17.0417 17.6672 16.6508 17.6674H3.34875C3.15521 17.6674 2.96357 17.6293 2.78477 17.5552C2.60597 17.4812 2.4435 17.3726 2.30665 17.2358C2.03027 16.9594 1.875 16.5845 1.875 16.1937V8.28325C1.87522 7.89234 2.03061 7.51751 2.30702 7.2411C2.58343 6.96469 2.95826 6.8093 3.34917 6.80908Z"
                          stroke="#062B3B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M10.0004 8.9233C10.0004 8.44857 9.61557 8.06372 9.14083 8.06372C8.6661 8.06372 8.28125 8.44857 8.28125 8.9233V8.92372C8.28125 9.39846 8.6661 9.7833 9.14083 9.7833C9.61557 9.7833 10.0004 9.39846 10.0004 8.92372V8.9233Z"
                          stroke="#062B3B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M9.12214 6.81742V5.08825C9.12214 4.72646 9.1934 4.36821 9.33185 4.03396C9.4703 3.69971 9.67323 3.396 9.92906 3.14017C10.1849 2.88435 10.4886 2.68142 10.8228 2.54296C11.1571 2.40451 11.5153 2.33325 11.8771 2.33325C12.2389 2.33325 12.5972 2.40451 12.9314 2.54296C13.2657 2.68142 13.5694 2.88435 13.8252 3.14017C14.081 3.396 14.284 3.69971 14.4224 4.03396C14.5609 4.36821 14.6321 4.72646 14.6321 5.08825V6.71867M9.60922 3.08117C9.19678 2.78924 8.712 2.61636 8.2079 2.58145C7.70381 2.54653 7.19982 2.65093 6.75108 2.88322C6.30233 3.11551 5.92611 3.46674 5.66358 3.89848C5.40105 4.33023 5.26231 4.82587 5.26255 5.33117V6.68992M5.1063 9.10075C5.1063 8.98787 5.08407 8.87609 5.04087 8.7718C4.99767 8.66751 4.93436 8.57275 4.85454 8.49293C4.77472 8.41311 4.67996 8.3498 4.57567 8.3066C4.47138 8.2634 4.3596 8.24117 4.24672 8.24117C4.13384 8.24117 4.02206 8.2634 3.91777 8.3066C3.81348 8.3498 3.71872 8.41311 3.6389 8.49293C3.55908 8.57275 3.49577 8.66751 3.45257 8.7718C3.40937 8.87609 3.38714 8.98787 3.38714 9.10075V15.3083M3.38672 15.3078C3.38672 15.4207 3.40895 15.5325 3.45215 15.6368C3.49535 15.7411 3.55867 15.8358 3.63848 15.9157C3.7183 15.9955 3.81306 16.0588 3.91735 16.102C4.02164 16.1452 4.13342 16.1674 4.2463 16.1674C4.35918 16.1674 4.47096 16.1452 4.57525 16.102C4.67954 16.0588 4.7743 15.9955 4.85412 15.9157C4.93394 15.8358 4.99726 15.7411 5.04045 15.6368C5.08365 15.5325 5.10589 15.4207 5.10589 15.3078V9.09992M14.7359 8.06367C14.9639 8.06367 15.1825 8.15423 15.3437 8.31543C15.5049 8.47664 15.5955 8.69528 15.5955 8.92325C15.5955 9.03617 15.5733 9.14799 15.5302 9.25233C15.487 9.35667 15.4237 9.45147 15.3438 9.53134C15.264 9.6112 15.1692 9.67456 15.0649 9.71778C14.9606 9.761 14.8488 9.78325 14.7359 9.78325C14.623 9.78325 14.5112 9.761 14.4068 9.71778C14.3025 9.67456 14.2077 9.6112 14.1279 9.53134C14.0481 9.45147 13.9848 9.35667 13.9416 9.25233C13.8984 9.14799 13.8762 9.03617 13.8763 8.92325C13.8763 8.69528 13.9669 8.47664 14.1281 8.31543C14.2893 8.15423 14.5079 8.06367 14.7359 8.06367Z"
                          stroke="#062B3B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <router-link to="/purchase">
                      {{ $t("purchases") }}
                    </router-link>
                  </li>

                  <!---<li>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M16.5831 10.55C16.4495 10.3979 16.3758 10.2024 16.3758 9.99999C16.3758 9.79757 16.4495 9.60207 16.5831 9.44999L17.6498 8.24999C17.7673 8.11888 17.8403 7.95391 17.8582 7.77875C17.8762 7.60359 17.8382 7.42723 17.7498 7.27499L16.0831 4.39166C15.9955 4.23959 15.8622 4.11906 15.702 4.04723C15.5419 3.97541 15.3632 3.95596 15.1914 3.99166L13.6248 4.30833C13.4254 4.34952 13.2179 4.31632 13.0413 4.21499C12.8648 4.11367 12.7314 3.95123 12.6664 3.75833L12.1581 2.23333C12.1022 2.06781 11.9957 1.92405 11.8536 1.82236C11.7115 1.72068 11.5411 1.66621 11.3664 1.66666H8.03308C7.85136 1.65718 7.67153 1.70743 7.52105 1.80976C7.37058 1.91208 7.25773 2.06084 7.19975 2.23333L6.73308 3.75833C6.66808 3.95123 6.53473 4.11367 6.35818 4.21499C6.18163 4.31632 5.9741 4.34952 5.77475 4.30833L4.16642 3.99166C4.00354 3.96864 3.8375 3.99435 3.68921 4.06553C3.54091 4.13671 3.417 4.25018 3.33308 4.39166L1.66642 7.27499C1.57572 7.42554 1.53494 7.6009 1.5499 7.77601C1.56487 7.95113 1.63482 8.11703 1.74975 8.24999L2.80808 9.44999C2.94168 9.60207 3.01536 9.79757 3.01536 9.99999C3.01536 10.2024 2.94168 10.3979 2.80808 10.55L1.74975 11.75C1.63482 11.883 1.56487 12.0489 1.5499 12.224C1.53494 12.3991 1.57572 12.5745 1.66642 12.725L3.33308 15.6083C3.42067 15.7604 3.55402 15.8809 3.71413 15.9528C3.87424 16.0246 4.05294 16.044 4.22475 16.0083L5.79142 15.6917C5.99077 15.6505 6.1983 15.6837 6.37484 15.785C6.55139 15.8863 6.68475 16.0488 6.74975 16.2417L7.25808 17.7667C7.31607 17.9391 7.42891 18.0879 7.57939 18.1902C7.72986 18.2926 7.9097 18.3428 8.09142 18.3333H11.4248C11.5995 18.3338 11.7699 18.2793 11.9119 18.1776C12.054 18.0759 12.1605 17.9322 12.2164 17.7667L12.7248 16.2417C12.7898 16.0488 12.9231 15.8863 13.0997 15.785C13.2762 15.6837 13.4837 15.6505 13.6831 15.6917L15.2498 16.0083C15.4216 16.044 15.6003 16.0246 15.7604 15.9528C15.9205 15.8809 16.0538 15.7604 16.1414 15.6083L17.8081 12.725C17.8966 12.5728 17.9345 12.3964 17.9166 12.2212C17.8986 12.0461 17.8256 11.8811 17.7081 11.75L16.5831 10.55ZM15.3414 11.6667L16.0081 12.4167L14.9414 14.2667L13.9581 14.0667C13.3579 13.944 12.7336 14.0459 12.2036 14.3532C11.6736 14.6604 11.2749 15.1515 11.0831 15.7333L10.7664 16.6667H8.63308L8.33308 15.7167C8.1413 15.1349 7.74257 14.6437 7.21259 14.3365C6.68261 14.0293 6.05827 13.9273 5.45808 14.05L4.47475 14.25L3.39142 12.4083L4.05808 11.6583C4.46805 11.2 4.69469 10.6066 4.69469 9.99166C4.69469 9.37672 4.46805 8.78335 4.05808 8.32499L3.39142 7.57499L4.45808 5.74166L5.44142 5.94166C6.0416 6.06435 6.66594 5.96239 7.19592 5.65516C7.7259 5.34792 8.12463 4.85679 8.31642 4.27499L8.63308 3.33333H10.7664L11.0831 4.28333C11.2749 4.86513 11.6736 5.35626 12.2036 5.66349C12.7336 5.97073 13.3579 6.07268 13.9581 5.94999L14.9414 5.74999L16.0081 7.59999L15.3414 8.34999C14.9361 8.80729 14.7122 9.39723 14.7122 10.0083C14.7122 10.6194 14.9361 11.2094 15.3414 11.6667ZM9.69975 6.66666C9.04048 6.66666 8.39601 6.86216 7.84785 7.22843C7.29969 7.5947 6.87244 8.1153 6.62015 8.72438C6.36786 9.33347 6.30185 10.0037 6.43047 10.6503C6.55908 11.2969 6.87655 11.8908 7.34273 12.357C7.8089 12.8232 8.40285 13.1407 9.04945 13.2693C9.69605 13.3979 10.3663 13.3319 10.9754 13.0796C11.5844 12.8273 12.105 12.4001 12.4713 11.8519C12.8376 11.3037 13.0331 10.6593 13.0331 9.99999C13.0331 9.11594 12.6819 8.26809 12.0568 7.64297C11.4317 7.01785 10.5838 6.66666 9.69975 6.66666ZM9.69975 11.6667C9.37012 11.6667 9.04788 11.5689 8.7738 11.3858C8.49972 11.2026 8.2861 10.9423 8.15995 10.6378C8.03381 10.3333 8.0008 9.99815 8.06511 9.67484C8.12942 9.35154 8.28815 9.05457 8.52124 8.82148C8.75433 8.5884 9.0513 8.42966 9.3746 8.36535C9.6979 8.30104 10.033 8.33405 10.3376 8.4602C10.6421 8.58634 10.9024 8.79996 11.0855 9.07404C11.2687 9.34813 11.3664 9.67036 11.3664 9.99999C11.3664 10.442 11.1908 10.8659 10.8783 11.1785C10.5657 11.4911 10.1418 11.6667 9.69975 11.6667Z"
                          fill="#062B3B" />
                      </svg>
                    </span>
                    <span> {{ $t('account_setting') }} </span>
                  </li>-->

                  <li @click="handleLogout">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M14.167 5.83333L12.992 7.00833L15.142 9.16667H6.66699V10.8333H15.142L12.992 12.9833L14.167 14.1667L18.3337 10M3.33366 4.16667H10.0003V2.5H3.33366C2.41699 2.5 1.66699 3.25 1.66699 4.16667V15.8333C1.66699 16.75 2.41699 17.5 3.33366 17.5H10.0003V15.8333H3.33366V4.16667Z"
                          fill="#062B3B" />
                      </svg>
                    </span>
                    <span> {{ $t("log_out") }} </span>
                  </li>
                </ul>
              </div>
            </div>
            <!----------------------->
            <!----------Notification DropDown------------->
            <div id="notification-dropdown" class="js-click-dropdown js-toggle-notification">
              <ul class="d-flex flex-column">
                <li v-for="item in notifications" :key="item?.slug">
                  <a :href="item?.resume_link" class="d-flex">
                    <div class="course-img d-flex align-items-center justify-content-center x-gap-5">
                      <img :src="item?.preview_image[0]?.url" width="" height="" alt="user-image" class="img-fluid" />
                      <!----<img :src="item?.preview_image[0]?.url" width="" height="" alt="user-image"
                       />-->
                    </div>
                    <div class="d-flex flex-column y-gap-5 user-name ml-10">
                      <div class="d-flex flex-column flex-md-row">
                        <p>
                          {{ item?.title }}
                        </p>
                        <span class="d-block mt-auto"> {{ item?.progress }}</span>
                        <!---progress Percentage-->
                      </div>
                      <!--Progress bar--->
                      <div class="mt-10">
                        <div class="progress">
                          <div class="progress-bar " role="progressbar"
                            :style="{ width: item?.progress ? `${item.progress}%` : '0%' }" aria-valuenow="25"
                            aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                      </div>
                      <!---------->
                    </div>
                  </a>
                </li>

                <li>
                  <a :href="userData ? userData['access_link'] : '/'" class="dashboard-btn fw-600"
                    aria-label="Dashboard">
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M16.0982 11.2501H12.869C12.441 11.2496 12.0302 11.419 11.7268 11.7209C11.4235 12.0229 11.2522 12.4329 11.2507 12.8609V16.0901C11.2505 16.3027 11.2922 16.5132 11.3734 16.7097C11.4547 16.9061 11.5739 17.0846 11.7242 17.2349C11.8745 17.3852 12.053 17.5044 12.2494 17.5857C12.4459 17.6669 12.6564 17.7086 12.869 17.7084H16.0982C16.5261 17.7067 16.9358 17.5353 17.2376 17.232C17.5394 16.9286 17.7086 16.518 17.7082 16.0901V12.8609C17.7084 12.6494 17.6669 12.44 17.5861 12.2445C17.5052 12.0491 17.3866 11.8715 17.2371 11.722C17.0876 11.5724 16.91 11.4539 16.7146 11.373C16.5191 11.2922 16.3097 11.2507 16.0982 11.2509M7.13067 11.2501H3.9015C3.47367 11.2525 3.06418 11.4242 2.7625 11.7276C2.46083 12.0309 2.2915 12.4414 2.2915 12.8692V16.0984C2.29129 16.3099 2.33278 16.5194 2.41361 16.7148C2.49444 16.9102 2.61303 17.0878 2.76257 17.2373C2.91212 17.3869 3.08969 17.5055 3.28513 17.5863C3.48056 17.6671 3.69002 17.7086 3.9015 17.7084H7.13067C7.55857 17.7089 7.9692 17.5396 8.27255 17.2379C8.57591 16.9361 8.74724 16.5263 8.749 16.0984V12.8692C8.74922 12.6567 8.70751 12.4461 8.62626 12.2497C8.54501 12.0532 8.42581 11.8747 8.27549 11.7244C8.12517 11.5741 7.94668 11.4549 7.75024 11.3737C7.5538 11.2924 7.34326 11.2507 7.13067 11.2509M7.13067 2.29175H3.9015C3.69002 2.29153 3.48056 2.33302 3.28513 2.41386C3.08969 2.49469 2.91212 2.61327 2.76257 2.76282C2.61303 2.91236 2.49444 3.08994 2.41361 3.28537C2.33278 3.4808 2.29129 3.69026 2.2915 3.90175V7.13092C2.29106 7.55882 2.46028 7.96944 2.76207 8.2728C3.06386 8.57615 3.47361 8.74748 3.9015 8.74925H7.13067C7.34326 8.74947 7.5538 8.70776 7.75024 8.62651C7.94668 8.54526 8.12517 8.42606 8.27549 8.27574C8.42581 8.12542 8.54501 7.94693 8.62626 7.75048C8.70751 7.55404 8.74922 7.3435 8.749 7.13092V3.90175C8.74724 3.47385 8.57591 3.0641 8.27255 2.76231C7.9692 2.46052 7.55857 2.2913 7.13067 2.29175ZM16.0982 2.29175H12.869C12.4411 2.2913 12.0305 2.46052 11.7271 2.76231C11.4238 3.0641 11.2524 3.47385 11.2507 3.90175V7.13092C11.2509 7.56006 11.4215 7.97156 11.7249 8.27501C12.0284 8.57845 12.4399 8.74903 12.869 8.74925H16.0982C16.5261 8.74748 16.9358 8.57615 17.2376 8.2728C17.5394 7.96944 17.7086 7.55882 17.7082 7.13092V3.90175C17.7084 3.69026 17.6669 3.4808 17.5861 3.28537C17.5052 3.08994 17.3866 2.91236 17.2371 2.76282C17.0876 2.61327 16.91 2.49469 16.7146 2.41386C16.5191 2.33302 16.3097 2.29153 16.0982 2.29175Z"
                          stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </span>
                    <span class="d-inline-block pt-1">{{ $t('dashboard') }}</span>
                  </a>
                </li>
              </ul>
            </div>
            <!----------------------->
          </div>
        </div>
      </div>
    </div>

  </header>
</template>

<script>
import clickElToggle from "@/directives/clickElToggle";
import MenuComponent from "./NewMenuComponent.vue";
import { Logout } from "@/Services/api/AuthService";
import store from "@/store";
import { coursesNotifications } from "@/Services/api/CoursesService";
import GlobalMixin from "@/Mixins/GlobalMixin";
export default {
  mixins: [GlobalMixin],
  components: {
    MenuComponent,
  },
  directives: {
    clickElToggle,
  },
  data() {
    return {
      timer: true,
      scrollY: 0,
      notifications: [],
      isSearchMenuVisible: false,
      searchTerm: "",
      isLoading: false,
      languages: [
        {
          code: "en",
          label: "English",
          direction: "ltr",
          flag: "https://flagcdn.com/w320/us.png",
        },
        {
          code: "ar",
          label: "العربية",
          direction: "rtl",
          flag: "https://flagcdn.com/w320/eg.png",
        },
      ],
    };
  },
  computed: {
    headerStyle() {
      return {
        position: this.scrollY > 50 ? 'fixed' : 'sticky', // Change scrollY value to suit your needs
        top: this.activePromotion ? '100px' : '0px',
        width: '100%',
        zIndex: 1000,
      };
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userData() {
      return this.$store.getters.userData;
    },
    currentLanguage() {
      return this.$i18n.locale === "en" ? "en" : "ar";
    },
    categories() {
      return this.$store.getters.categories;
    },
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    //get notifications
    async getNotifications() {
      try {
        this.isLoading = true;
        this.$emit('update-mycourses', this.notifications, this.isLoading); // Emit immediately to show loader
        if (this.isAuthenticated) {
          let response = await coursesNotifications();
          this.notifications = response.data;
        } else {
          this.notifications = [];
        }
        this.$emit('update-mycourses', this.notifications, this.isLoading);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
        this.$emit('update-mycourses', this.notifications, this.isLoading);
      }
    },

    //toggle Search menu
    toggleSearchMenu() {
      this.isSearchMenuVisible = !this.isSearchMenuVisible;
    },

    hideSearchMenu() {
      this.isSearchMenuVisible = false;
    },

    //send search data by coures Name or instarctor name
    searchData() {
      setTimeout(() => {
        if (this.$route.path !== "/courses") {
          this.$router.push("/courses");
        }
        store.commit("setSearchTerm", this.searchTerm.toLowerCase());
        this.hideSearchMenu();
      }, 500);
    },

    //get filtered courses by caegories
    goToFilteredCoureses(val) {
      this.$store.commit("setSelectedCategories", [val]);
      this.$router.push("/courses");
    },

    //hide sidebar in small screens
    hideSidebar() {
      const element = document.querySelector(".js-mobile-menu-toggle");
      if (element) {
        element.classList.remove("-is-el-visible");
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = true;
    },

    //Logout
    async handleLogout() {
      try {
        await Logout();
        this.$store.commit("setUserData", null);
        this.$store.commit("setAccessToken", "");
        this.$store.commit("setAuthenticated", false),
          localStorage.removeItem("accessToken");
        localStorage.removeItem("userData");
      } catch (error) {
        console.log("An error occurred while logging out.");
      }
    },

    changeLanguage(code, direction) {
      // Update i18n locale
      (this.$i18n.locale = code),
        this.$store.dispatch("updateLanguage", code),
        this.$store.dispatch("updateDirection", direction),
        // Update document direction
        (document.body.dir = direction);

      // Store in localStorage
      localStorage.setItem("language", code);
      localStorage.setItem("direction", direction);

      this.$parent.language = code;
      this.$parent.$emit("language-changed", code);

      window.dispatchEvent(
        new CustomEvent("direction-localstorage-changed", {
          detail: {
            storage: localStorage.getItem("direction"),
          },
        })
      );
    },
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.getNotifications();
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    store.dispatch("fetchUserData");
    //store.dispatch("categoriesList");
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.learning {
  &:lang(ar) {
    margin-left: 13px;
  }
}

.progress-bar {
  background: #94ad04;
}

.progress,
.progress-stacked {
  height: 10px;
}

.input-group-text {
  background: transparent;
  border: none;
}

.mobile-footer {
  position: absolute;
  bottom: 20px;
  background: #fff;
  z-index: 1000;
  width: 100%;
}

.mobile-socials {
  svg {
    path {
      fill: #09445d;
    }

    &:hover {
      cursor: pointer;

      path {
        fill: #197399c7;
      }
    }
  }
}
</style>
